<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Async Task</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  @if (asyncCommand) {
    <div>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between">
        <h3 class="fw-bold fs-6 mb-0">Information</h3>
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{{ asyncCommand.id }}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{ asyncCommand.description }}</td>
          </tr>
          <tr>
            <th>Command</th>
            <td class="text-monospace">{{ asyncCommand.buildCommandLine() }}</td>
          </tr>
          <tr>
            <th>Started at</th>
            <td>{{ asyncCommand.startedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          </tr>
          <tr>
            <th>Ended at</th>
            <td>{{ asyncCommand.endedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{{ asyncCommand.status }}</td>
          </tr>
        </tbody>
      </table>
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 mb-3 d-flex align-items-center justify-content-between mt-5">
        <h3 class="fw-bold fs-6 mb-0">Output</h3>
      </div>
      <div style="background-color: black; color: white; line-height: 2em; overflow: auto; padding: .5em; font-family: monospace;">
        <div [innerHTML]="(asyncCommand.output ?? '') | keepHtml"></div>
      </div>
    </div>
  }
</div>
